import React from "react";
import { useSelector } from "react-redux";
import GoogleChart from "../../../../components/charts/googleChart/googleChart";

const LineChart = () => {
  const {
    data_table: { rows = [], cols: columns = [] },
    options
  } = useSelector((state) => state.activeClients.chartData);

  return (
    <GoogleChart
      columns={columns}
      rows={rows}
      options={options}
      chartName="attendance_active_clients_line_chart"
      width="1350px"
      enableEventListeners
      showCurrency={false}
      showAdditionTooltip={false}
      height={400}
      chartType="LineChart"
    />
  );
};

export default LineChart;
